import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal, NgbModal, ModalDismissReasons, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from '../home/user'
import { Router } from '@angular/router';
import { Idle } from '@ng-idle/core';
import { ServerService } from '../../../service/server.service'
import { ModalService } from '../../../pages/email-activation/modal.service'
import { REGISTRATION_MITRA_URL } from 'src/app/constants/api-bis.constant';
import { FORGOT_PASSWORD, LOGIN_MITRA_URL, environment } from 'src/environments/environment';
import { LayoutService } from 'src/app/shared/services/layout.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

declare var require
const Swal = require('sweetalert2')

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @ViewChild("login") loginModalContent: TemplateRef<any>;

  regisUrl =environment.path.base + environment.path.partner.base +environment.path.partner.user

  captchaUrl = environment.path.base + environment.path.partner.base + "/user/generate-captcha"


  public show: boolean = false;
  public reShow: boolean = false;
  isNextRegist: boolean = true;
  closeResult: string;
  bgImgUrl: string;
  public loginForm: FormGroup;
  public registerForm: FormGroup;
  public contactForm: FormGroup;
  captchaId:string;
  disable: Boolean 
  isSamePass: boolean
  imageBase64: SafeResourceUrl;
  constructor(config: NgbDropdownConfig,
    config1: NgbModalConfig,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private router: Router,
    private idle: Idle,
    private server: ServerService,
    private modal: ModalService,
    public layout: LayoutService,
    private sanitizer: DomSanitizer,
  ) {
    // customize default values of dropdowns used by this component tree
    config.placement = 'top-left';
    config.autoClose = false;
    config1.backdrop = 'static';
    config1.keyboard = false;
    this.contactForm = fb.group({
      email: ['',[Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/), Validators.email]],
      name: ['',[Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/)]],
      contact: ['',[Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/)]],
      message: ['',[Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/)]]
    })
    this.loginForm = fb.group({
      email: ['',[Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/)]],
      password: ['',[Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/)]],
      captcha:[null,[Validators.required,Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/)]]
    });
    this.registerForm = fb.group({
      fullname: [null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/)]],
      email: [null, [Validators.required, Validators.email, Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/)]],
      phone: [null, [Validators.required, Validators.pattern(/^\d{9,15}$/)]],
      company: [null, Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/)], 
      password: [null, [Validators.required, Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z0-9])/), Validators.minLength(8), Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/)]],
      confirmPassword: [null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/)]],
      countrycode:[null]
    });

    this.modal.currentMessage.subscribe((res: any) => {
      if (res === 'open') {
        this.openLg(this.loginModalContent);
      }

    })
  }

  get v() {
    return this.registerForm.controls
  }

  get l() {
    return this.loginForm.controls
  }

  get c() {
    return this.contactForm.controls
  }


  showPassword() {
    this.show = !this.show;
  }

  reShowPassword() {
    this.reShow = !this.reShow;
  }

  open(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    this.loginForm.reset();
    this.server.doGet(this.captchaUrl).subscribe(async resp => {
      this.imageBase64 = this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64, ' + resp.data.captcha);
      this.captchaId = resp.data.captchaId;
    })
  }

  openBackDropCustomClass(content) {
    this.modalService.open(content, { backdropClass: 'light-blue-backdrop' });
  }

  openWindowCustomClass(content) {
    this.modalService.open(content, { windowClass: 'dark-modal' });
  }

  openSm(content) {
    this.modalService.open(content, { size: 'sm' });
  }

  openLg(content) {
    this.registerForm.reset();
    this.registerForm.controls.countrycode.setValue("+"+62);
    this.modalService.open(content, { size: 'lg'});
  }

  openVerticallyCentered(content) {
    this.modalService.open(content, { centered: true });
  }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onBlurConfirmPass(event){
    this.isSamePass = event? event.target.value!=this.registerForm.value.password : false;
  }

  signIn() {
    this.disable=true
    if (this.loginForm.value.email == "" || this.loginForm.value.password == "") {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Email and password is required.',
      });
      this.disable=false
    } else {
      //login
      this.auth();
    }
  }

  registerValidation() {
    this.disable=true
    // check field yang required udah diisi apa belum
    if (!this.requiredFieldregister()) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Semua field  harus diisi',
      });
      this.isNextRegist = true;
      this.disable=false
    }
    // check pass have to same with confirm pass
    else if (this.registerForm.value.password != this.registerForm.value.confirmPassword) {
      Swal.fire('Failure!', 'password dan confirm password tidak cocok', 'error');
      this.disable=false
    } else {
      //sent req register user mitra to BEs
      const data = this.registerForm.value;
      const requestJson ={
        fullname:data.fullname,
        email:data.email,
        phone:data.countrycode+data.phone,
        company:{name:data.company},
        password:data.password,
        confirmPassword:data.confirmPassword
      }
      this.server.doPost(requestJson, this.regisUrl+'/registration').subscribe(async resp => {
        if (resp) {
          Swal.fire('Succes!', resp['message'], 'success');
          this.modalService.dismissAll();
        } else {
          Swal.fire('Failure!', resp['message'], 'error');
          this.disable=false
        }
      }, (error) => {
        this.disable=false
    }); 
    }
  }

  forgotPassword() {
    const jsonData = {
      "email": this.loginForm.value.email
    }
    this.server.doPost(jsonData, FORGOT_PASSWORD).subscribe(async resp => {
      if (resp) {
        Swal.fire('Success!', resp['message'], 'success');
      } else {
        Swal.fire('Failure!', resp['message'], 'error');
      }
    });
  }

  private auth() {
    const loginForm = this.loginForm.value;
    const data = {
      email : loginForm.email,
      password:loginForm.password,
      captchaId:this.captchaId,
      captchaText:loginForm.captcha,
    }
    this.server.doPost(data, LOGIN_MITRA_URL).subscribe(async resp => {
      if (resp) {
        localStorage.setItem('access', '');
        localStorage.setItem('menuInfo', JSON.stringify(resp.data.menus));
        console.log('isi session: ' + localStorage.getItem('menuInfo'));
        localStorage.setItem('grantedInfo', '');
        localStorage.setItem('userInfo', JSON.stringify(resp.data.profile));
        localStorage.setItem('token', resp.token);

        this.router.navigate(['/dashboard/default']);
        this.modalService.dismissAll();

        //Start Session
        this.idle.watch();
      } else {
        Swal.fire('Failure!', resp['message'], 'error');
        this.disable=false
      }
    }, (error) => {
      this.reloadCaptcha()
      this.disable=false
  });  
  }

  private requiredFieldregister() {

    if (this.registerForm.value.fullname == "") {
      this.isNextRegist = false;
    }
    if (this.registerForm.value.email == "") {
      this.isNextRegist = false;
    }
    if (this.registerForm.value.phone == "") {
      this.isNextRegist = false;
    }
    if (this.registerForm.value.password == "") {
      this.isNextRegist = false;
    }
    if (this.registerForm.value.confirmPassword == "") {
      this.isNextRegist = false;
    }

    return this.isNextRegist;
  }

  owlcarousel1 = [
    { id: 1, img: "assets/images/slider/1.jpg" },
    { id: 2, img: "assets/images/slider/2.jpg" },
    { id: 3, img: "assets/images/slider/3.jpg" },
    { id: 4, img: "assets/images/slider/4.jpg" },
    { id: 5, img: "assets/images/slider/5.jpg" },
    { id: 6, img: "assets/images/slider/6.jpg" },
    { id: 7, img: "assets/images/slider/7.jpg" },
    { id: 8, img: "assets/images/slider/8.jpg" },
    { id: 9, img: "assets/images/slider/9.jpg" },
    { id: 10, img: "assets/images/slider/10.jpg" }
  ];

  //Options
  owlcarousel1Options = {
    loop: true,
    margin: 10,
    nav: false,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 3
      },
      1000: {
        items: 5
      }
    }
  };

  owlcarousel2Options = {
    loop: true,
    margin: 10,
    items: 5,
    nav: false,
    responsive: {
      576: {
        items: 1
      },
      768: {
        items: 2
      },
      992: {
        items: 3
      }
    }
  }


  owlcarousel3Options = {
    center: true,
    items: 5,
    loop: true,
    margin: 10,
    nav: false,
    responsive: {
      576: {
        items: 1
      },
      768: {
        items: 2
      },
      992: {
        items: 3
      }
    }
  }

  owlcarousel4Options = {
    items: 5,
    loop: true,
    margin: 10,
    merge: true,
    nav: false,
    responsive: {
      576: {
        items: 1,
        mergeFit: true
      },
      768: {
        items: 2,
        mergeFit: true
      },
      992: {
        items: 3,
        mergeFit: true

      }
    }
  }

  owlcarousel5Options = {
    margin: 10,
    loop: true,
    autoWidth: true,
    items: 5,
    nav: false
  }

  owlcarousel6Options = {
    items: 5,
    loop: false,
    center: true,
    margin: 10,
    URLhashListener: true,
    autoplayHoverPause: true,
    startPosition: 'URLHash',
    nav: false,
    responsive: {
      576: {
        items: 1,
        mergeFit: true
      },
      768: {
        items: 2,
        mergeFit: true
      },
      992: {
        items: 3,
        mergeFit: true

      }
    }
  }

  owlcarousel7Options = {
    stagePadding: 50,
    loop: true,
    margin: 10,
    nav: false,
    responsive: {
      576: {
        items: 1,
        mergeFit: true
      },
      768: {
        items: 2,
        mergeFit: true
      },
      992: {
        items: 3,
        mergeFit: true

      }
    }
  }

  owlcarousel8Options = {
    stagePadding: 50,
    loop: true,
    margin: 10,
    nav: false,
    responsive: {
      576: {
        items: 1,
        mergeFit: true
      },
      768: {
        items: 2,
        mergeFit: true
      },
      992: {
        items: 3,
        mergeFit: true

      }
    }
  }

  owlcarousel9Options = {
    rtl: true,
    loop: true,
    margin: 10,
    nav: false,
    responsive: {
      576: {
        items: 1,
        mergeFit: true
      },
      768: {
        items: 2,
        mergeFit: true
      },
      992: {
        items: 3,
        mergeFit: true

      }
    }
  }

  owlcarousel10Options = {
    items: 5,
    lazyLoad: true,
    loop: true,
    margin: 5,
    nav: false,
    responsive: {
      576: {
        items: 1,
        mergeFit: true
      },
      768: {
        items: 2,
        mergeFit: true
      },
      992: {
        items: 3,
        mergeFit: true

      }
    }
  }

  owlcarousel12Options = {
    animateOut: 'slideOutDown',
    animateIn: 'flipInX',
    items: 5,
    margin: 30,
    stagePadding: 30,
    smartSpeed: 450,
    nav: false,
    responsive: {
      576: {
        items: 1,
        mergeFit: true
      },
      768: {
        items: 2,
        mergeFit: true
      },
      992: {
        items: 3,
        mergeFit: true

      }
    }
  }

  owlcarousel13Options = {
    items: 5,
    loop: true,
    margin: 10,
    autoplay: true,
    autoplayTimeout: 1000,
    autoplayHoverPause: true,
    nav: false,
    responsive: {
      576: {
        items: 1,
        mergeFit: true
      },
      768: {
        items: 2,
        mergeFit: true
      },
      992: {
        items: 3,
        mergeFit: true

      }
    }
  }

  owlcarousel14Options = {
    items: 1,
    margin: 10,
    autoHeight: true,
    nav: false
  }

  styleTenantNavbar(){
    if(this.layout.getTenant()=='Bankaltimtara'){
      return ({'background-color': 'white',
      'padding-top': '0rem',
      'padding-bottom': '0rem'})
    }else{
      return ({'background-color': 'transparent',
      'padding-top': '1.563rem',
      'padding-bottom': '1.563rem'})
    }
  }

  ngOnInit(): void {
    

    var tenant:any = this.layout.tenant

    switch(tenant){
      case "Bank Banten" :
        this.bgImgUrl = 'url(/assets/images/landing/backgroud_banten.jpg)'
        break; 
      case "Bankaltimtara" :
        this.bgImgUrl = 'url(/assets/images/landing/background_kaltim.png)'
        break;  
      default:
        this.bgImgUrl = 'url(/assets/images/landing/background.jpg)'
        break;
    }
  }

  reloadCaptcha() {
    this.server.doGet(this.captchaUrl).subscribe(async resp => {
      this.imageBase64 = this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64, ' + resp.data.captcha);
      this.captchaId = resp.data.captchaId;
      this.loginForm.controls.captcha.setValue('');
    })
  }

}
